module.exports = __webpack_public_path__ + "img/level_10_diamond.f2eb98c0.svg";